import React from "react";
import { connect } from "react-redux";
import { Page, Title } from "EventLight/Common/FieldLayout";
import { BigFilledButton } from "components/Base";
import { refreshCache } from "../actions";
import Loading from "ui-kit/Loading";

const Layout = ({ onRefreshCache, isFetching }) => {
  return (
    <Page>
      <Title
        icon="cached"
        title="Cache Management"
        description="Manage application cache settings"
        buttons={
          <BigFilledButton
            icon="refresh"
            bg="altB5"
            ml={2}
            onClick={onRefreshCache}
            isLoading={isFetching}
          >
            Refresh Cache
          </BigFilledButton>
        }
        supportId="cache-management"
      />
      {isFetching && <Loading height={200} iconSize={40} />}
    </Page>
  );
};

const mapStateToProps = state => ({
  isFetching: state.cacheManagement.fetching
});

const mapDispatchToProps = {
  onRefreshCache: refreshCache
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
